import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import PanelOnBoarding from './views/panel/PanelOnBoarding.vue'
import AccountActivation from './views/AccountActivation.vue'
import AccountInvitation from './views/AccountInvitation.vue'
import ProviderProfile from './views/ProviderProfile.vue'
import ProviderPublicProfile from './views/ProviderPublicProfile.vue'
import ProviderRating from './views/ProviderRating.vue'

import PanelDashboard from './views/panel/PanelDashboard.vue'
import PanelActivateAccount from './views/panel/PanelActivateAccount.vue'

import NotFound from './views/NotFound.vue'

import { ApiUtils } from '@/utils/ApiUtils'
import { hasAccess } from '@/utils/Auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/panel/initial-config',
      name: 'panel.onboarding',
      component: PanelOnBoarding,
      meta: {
        animationBG: false,
        animationBGLoop: true,
        menu: false,
        footer: false,
        public: false
      }
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        menu: false,
        footer: false,
        public: true,
        animationBG: true
      }
    },
    {
      path: '/videocall/:callId',
      name: 'appointment.video',
      component:  () => import('@/views/VideoAppointment'),
      meta: {
        animationBGLoop: false,
        menu: false,
        footer: false,
        public: true
      }
    },
    {
      path: '/payments/:eventId',
      name: 'appointment.payment',
      component:  () => import('@/views/PayAppointment'),
      meta: {
        animationBG: true,
        animationBGLoop: false,
        menu: false,
        footer: false,
        public: true
      }
    },
    {
      path: '/appointment/:providerId',
      name: 'appointment',
      component:  () => import('@/views/Appointment'),
      meta: {
        menu: true,
        footer: true,
        public: true
      }
    },
    {
      path: '/special-sales',
      name: 'special_sales',
      component: () => import('@/views/SpecialSalesList'),
      meta: {
        menu: true,
        footer: true,
        public: true
      }
    },
    {
      path: '/providers/:id/profile',
      name: 'provider.profile',
      component: ProviderProfile,
      meta: {
        menu: false,
        footer: true,
        transparentMenu: true,
        public: true
      }
    },
    {
      path: '/account/activate/:code',
      name: 'account.activate',
      component: AccountActivation,
      meta: {
        menu: false,
        footer: false,
        public: true
      }
    },
    {
      path: '/client/account/activate/:code',
      name: 'client.account.activate',
      component: () => import('@/views/PatientSignUpConfirm'),
      meta: {
        menu: false,
        footer: false,
        public: true
      }
    },
    {
      path: '/password/reset/:code',
      name: 'password.reset',
      component: () =>import('@/views/PasswordReset'),
      meta: {
        menu: false,
        footer: false,
        public: true
      }
    },

    {
      path: '/appointment/confirm/:code',
      name: 'appointment.confirm',
      component: () => import('@/views/AppointmentConfirm'),
      meta: {
        menu: false,
        footer: false,
        public: true
      }
    },

    {
      path: '/account/invitation/:code',
      name: 'account.invitation',
      component: AccountInvitation,
      meta: {
        menu: false,
        footer: false,
        public: true
      }
    },

    // Ratings
    {
      path: '/providers/ratings/:id',
      name: 'provider.rating.id',
      component: ProviderRating,
      meta: {
        menu: true,
        footer: true,
        public: true
      }
    },

    // Panel
    {
      path: '/panel/',
      name: 'panel',
      meta:{
        menu: true,
        footer: false
      },
      component: () => import('@/layouts/Panel'),
      children: [
        {
          path: 'dashboard',
          name: 'panel.dashboard',
          component: PanelDashboard,
          meta: {
            menu: true,
            footer: false,
            animationBG: true,
            subscription: {
              verify: true,
              block: true
            }
          }
        },
        {
          path: 'user/info',
          name: 'panel.user.info',
          component: () => import('@/views/panel/PanelDatos'),
          meta: {
            menu: true,
            footer: false
          }
        },

        {
          path: '/accounts',
          name: 'panel.super.accounts',
          component: () => import('@/views/panel/PanelAccountsList'),
          meta: {
            menu: true,
            footer: true,
          }
        },

        {
          path: '/plans',
          name: 'panel.super.plans',
          component: () => import('@/views/panel/PanelPlans'),
          meta: {
            menu: true,
            footer: false,
          }
        },

        {
          path: '/coupons',
          name: 'panel.super.coupons',
          component: () => import('@/views/panel/PanelCoupons'),
          meta: {
            menu: true,
            footer: false,
          }
        },

        {
          path: 'account/:id/info',
          name: 'panel.super.account.info',
          component: () => import('@/views/panel/PanelAccountInfo'),
          meta: {
            menu: false,
            footer: false
          }
        },

        {
          path: 'user/appointments',
          name: 'panel.user.appointments',
          component: () => import('@/views/panel/PanelAgenda'),
          meta: {
            menu: true,
            footer: false
          }
        },
        {
          path: 'user/quotation-requests',
          name: 'panel.user.quotation_requests',
          component: () => import('@/views/panel/PanelPresupuestos'),
          meta: {
            menu: true,
            footer: false
          }
        },
      {
        path: 'provider/specialist/schedule',
        name: 'panel.provider.specialist_daily_schedule',
        component: () => import('@/views/panel/HealthInstitutionDailyAttention'),
        props: true,
        meta:{
            title: 'Atención',
            animationBG: true,
            bgPaused: true,
            menu: true,
            footer: false
        }
      },
      {
        path: 'provider/schedule',
        name: 'panel.provider.schedule',
        component: () => import('@/views/panel/PanelProviderSchedule'),
        meta:{
          menu: true,
          footer: false
        }
      },
      {
        path: 'provider/my-schedules',
        name: 'panel.provider.my_schedules',
        component: () => import('@/views/panel/PanelMySchedules'),
        meta:{
          menu: true,
          footer: false
        }
      },
      {
        path: 'provider/appointments',
          name: 'panel.provider.appointments',
          component: () => import('@/views/panel/PanelProviderAppointments'),
          meta:{
            title: 'Recepción',
            animationBG: true,
            menu: true,
            footer: false
          }
      },

      {
        path: 'provider/gallery',
          name: 'panel.provider.gallery',
          component: () => import('@/views/panel/PanelProviderGallery'),
          meta:{
            menu: true,
            footer: false
          }
      },
        {
          path: 'provider/schedule/:id',
          name: 'panel.provider.schedule.details',
          component: () => import('@/views/panel/PanelProviderScheduleDetails'),
          meta:{
              menu: true,
              footer: false
          }
        },
        {
          path: 'provider/my-schedules/:id',
          name: 'panel.provider.my_schedules.details',
          component: () => import('@/views/panel/PanelProviderScheduleDetails'),
          meta:{
              menu: true,
              footer: false
          }
        },
        {
          path: 'provider/quotation-requests',
          name: 'panel.provider.quotation_requests',
          component: () =>
            import('@/views/panel/PanelProviderQuotationRequest'),
          meta: {
            menu: true,
            footer: false
          }
        },
        {
          path: 'provider/quotations',
          name: 'panel.provider.quotations',
          component: () =>
            import('@/views/panel/PanelProviderQuotations'),
          meta: {
            menu: true,
            footer: false
          }
        },

        {
          path: 'provider/members',
          name: 'panel.provider.members',
          component: () => import('@/views/panel/PanelProviderMembers'),
          meta: {
            menu: true,
            footer: false,
            showBranchOfficePicker: false
          }
        },

        {
          path: 'provider/special-sales',
          name: 'panel.provider.special_sales',
          component: () => import('@/views/panel/PanelProviderOffers'),
          meta: {
            menu: true,
            footer: false
          }
        },
        {
          path: 'user/special-sales',
          name: 'panel.user.special_sales',
          component: () => import('@/views/panel/PanelPromociones'),
          meta: {
            menu: true,
            footer: false
          }
        },
        {
          path: 'provider/settings',
          name: 'panel.provider.settings',
          component: () => import('@/views/panel/PanelSettings'),
          meta: {
            menu: true,
            footer: false,
            globalSpinner: true,
            subscription:{
              verify: false,
              block: false
            }
          }
        },
        {
          path: 'provider/clients',
          name: 'panel.provider.clients',
          component: () => import('@/views/panel/PanelClients'),
          meta: {
            menu: true,
            footer: false
          }
        },
        {
          path: 'provider/services',
          name: 'panel.provider.services',
          component: () => import('@/views/panel/PanelServices'),
          meta: {
            menu: true,
            footer: false
          }
        },
        {
          path: 'provider/branches',
          name: 'panel.provider.branches',
          component: () => import('@/views/panel/PanelBranchOffices'),
          meta: {
            title: 'Sucursales',
            animationBG: true,
            menu: true,
            footer: false,
            showBranchOfficePicker: false
          }
        },
        {
          path: 'account/activate',
          name: 'panel.account.activate',
          component: PanelActivateAccount,
          meta: {
            menu: true,
            footer: false
          }
        },
        {
          path: 'subscription/validate/:token',
          name: 'panel.subscription.validate',
          component: () => import('@/views/panel/PanelSubscriptionValidation'),
          meta: {
            menu: false,
            footer: false,
            fetchMe: false,
            subscription:{
              verify: false,
              block: false
            },
            public: true
          },
        }
      ]
    },

    {
      path: '/:slug',
      name: 'provider.profile.public',
      component: ProviderPublicProfile,
      meta: {
        menu: false,
        footer: false,
        transparentMenu: true,
        public: true
      }
    },

    {
      path: '/404',
      component: NotFound,
      meta: {
        menu: false,
        footer: false,
        public: true
      }
    },
    {
      path: '/401',
      name: 'unauthorized',
      component: Home,
      meta: {
        animationBG: true,
        animationBGLoop: false,
        menu: false,
        footer: false,
        public: true
      }
    },
    {
      path: '*',
      redirect: '/404',
      public: true
    }
  ]
})

import store from "./store";

router.beforeEach(async (to, from, next) => {
  console.log('going to:', to.name)
  if (to.meta && to.meta.public) {
    console.log('public route')
    next()
  } else {

    if((to.name !== 'panel.dashboard' && !store.state.currentProvider) || (to.name === 'panel.dashboard' && !store.state.currentUser)){
      console.log('fetchMe from router...')
      await ApiUtils.fetchMe()
    }

    if(store.state.currentUser && store.state.currentUser.active && !store.getters.isOnBoardingDone && to.name !== 'panel.onboarding'){
      next({ name: 'panel.onboarding' })
    }

    if (!hasAccess(to.name)) {
      console.log('no access to:', to.name)
      localStorage.failedUrl = to.fullPath

      if (Number(localStorage.prevFail) === 1) {
        localStorage.prevFail = 0
        next({ name: 'panel.dashboard' })
      } else {
        localStorage.prevFail = 1
        await ApiUtils.logout(false)
        next({ name: 'unauthorized' })
      }
    } else {
      next()
    }
  }
})

export default router
